var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.375C21.5 9.067 17.47 11.25 12.5 11.25C7.53 11.25 3.5 9.067 3.5 6.375C3.5 3.683 7.53 1.5 12.5 1.5C17.47 1.5 21.5 3.683 21.5 6.375Z",
    fill: "#3C45FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.7501C15.185 12.7501 17.69 12.1641 19.578 11.1411C20.2728 10.7722 20.9116 10.3062 21.475 9.75708C21.491 9.87808 21.5 10.0011 21.5 10.1251C21.5 12.8171 17.47 15.0001 12.5 15.0001C7.53 15.0001 3.5 12.8171 3.5 10.1251C3.5 10.0011 3.509 9.87808 3.525 9.75708C4.08842 10.3061 4.72716 10.7722 5.422 11.1411C7.309 12.1641 9.815 12.7501 12.5 12.7501Z",
    fill: "#3C45FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5001C15.185 16.5001 17.69 15.9141 19.578 14.8911C20.2729 14.5222 20.9116 14.0562 21.475 13.5071C21.491 13.6281 21.5 13.7511 21.5 13.8751C21.5 16.5671 17.47 18.7501 12.5 18.7501C7.53 18.7501 3.5 16.5671 3.5 13.8751C3.5 13.7511 3.509 13.6281 3.525 13.5071C4.08841 14.0561 4.72716 14.5222 5.422 14.8911C7.309 15.9141 9.815 16.5001 12.5 16.5001Z",
    fill: "#3C45FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.2501C15.185 20.2501 17.69 19.6641 19.578 18.6411C20.2729 18.2722 20.9116 17.8062 21.475 17.2571C21.491 17.3781 21.5 17.5011 21.5 17.6251C21.5 20.3171 17.47 22.5001 12.5 22.5001C7.53 22.5001 3.5 20.3171 3.5 17.6251C3.5 17.5011 3.509 17.3781 3.525 17.2571C4.08841 17.8061 4.72716 18.2722 5.422 18.6411C7.309 19.6641 9.815 20.2501 12.5 20.2501Z",
    fill: "#3C45FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/plate.2f5f743f7bef94c60d62125613cf1416.svg";
export { ForwardRef as ReactComponent };